/* unplugin-vue-components disabled */import { render } from "./Content.vue?vue&type=template&id=7105c446&scoped=true"
import script from "./Content.vue?vue&type=script&lang=js"
export * from "./Content.vue?vue&type=script&lang=js"

import "./Content.vue?vue&type=style&index=0&id=7105c446&lang=less&scoped=true"

import exportComponent from "C:\\Users\\10938\\Desktop\\ysjf1\\采购\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7105c446"]])

export default __exports__